import { useAppSelector } from "../redux/store"
import { selectCustomerNumber } from "../redux/customer"
import { useParams } from "react-router-dom"

const useCustomerNumber = () => {
  const values = {
    route: useParams().customerNumber,
    store: useAppSelector(selectCustomerNumber),
  }

  const customerNumber = values.route ?? values.store

  return customerNumber
}

export default useCustomerNumber
